var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowToLineTop18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.291 10.296a1 1 0 0 0 0-1.414L9.706 5.296a1 1 0 0 0-1.414 0L4.706 8.882a1 1 0 0 0 0 1.414c.39.39 1.018.417 1.409.027l1.884-1.907V16A1 1 0 0 0 10 16V8.417l1.878 1.879a1 1 0 0 0 1.414 0zM1 2c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H2c-.555 0-1 .448-1 1z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEzLjI5MSAxMC4yOTZhMSAxIDAgMCAwIDAtMS40MTRMOS43MDYgNS4yOTZhMSAxIDAgMCAwLTEuNDE0IDBMNC43MDYgOC44ODJhMSAxIDAgMCAwIDAgMS40MTRjLjM5LjM5IDEuMDE4LjQxNyAxLjQwOS4wMjdsMS44ODQtMS45MDdWMTZBMSAxIDAgMCAwIDEwIDE2VjguNDE3bDEuODc4IDEuODc5YTEgMSAwIDAgMCAxLjQxNCAwek0xIDJjMCAuNTU2LjQ0OCAxIDEgMWgxNGMuNTU1IDAgMS0uNDQ4IDEtMSAwLS41NTYtLjQ0OC0xLTEtMUgyYy0uNTU1IDAtMSAuNDQ4LTEgMXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgArrowToLineTop18 as ReactComponent };